<template>
    <div class="eml-show-mail-container">
        <div class="eml-email">
            <div class="eml-topbar">
                <div class="header-buttons">
                    <o-tooltip label="Go back">
                        <router-link class="header-button navbar-item between-center" :to="goback_link" active-class="">
                            <o-icon icon="arrow-left" pack="fa"> </o-icon>
                        </router-link>
                    </o-tooltip>
                    <o-tooltip label="Delete" v-if="belongs_to_current_user">
                        <a class="header-button navbar-item between-center" @click.prevent="handle('trash_thread')">
                            <o-icon icon="trash" pack="fa"> </o-icon>
                        </a>
                    </o-tooltip>
                    <o-tooltip label="Mark as unread" v-if="belongs_to_current_user">
                        <a class="header-button navbar-item between-center"
                            @click.prevent="handle('mark_thread_as_unread')">
                            <o-icon icon="envelope" pack="fa"></o-icon>
                        </a>
                    </o-tooltip>
                </div>
            </div>
            <header class="eml-email-header">
                <div class="eml-header-title">
                    <p class="title">{{ message_subject }}</p>
                    <div class="actions">
                        <a href="#" @click.prevent="handleAddToWork">{{
                            add_to_work_text
                        }}</a>
                        <add-contact :contact-text="contact_text" />
                    </div>
                </div>
                <div class="header-buttons">
                    <a class="header-button navbar-item between-center" @click.prevent="handleAddToWork">
                        <o-icon pack="fa" icon="briefcase"> </o-icon>
                    </a>
                    <o-dropdown position="bottom-left">
                        <template v-slot:trigger>
                            <a class="header-button navbar-item between-center">
                                <o-icon pack="fa" icon="ellipsis-v"> </o-icon>
                            </a>
                        </template>
                        <o-dropdown-item has-link>
                            <a href="#" @click.prevent="handle('reply')">Reply</a>
                        </o-dropdown-item>
                        <o-dropdown-item has-link>
                            <a href="#" @click.prevent="handle('replyAll')">Reply All</a>
                        </o-dropdown-item>
                        <o-dropdown-item has-link>
                            <a href="#" @click.prevent="handle('forward')">Forward</a>
                        </o-dropdown-item>
                        <hr class="dropdown-divider" />
                        <o-dropdown-item has-link>
                            <a href="#" @click.prevent="handleAddToWork">{{
                                add_to_work_text
                            }}</a>
                        </o-dropdown-item>
                    </o-dropdown>
                </div>
            </header>
            <div class="eml-email-content">
                <div :class="['eml-messages-box-ctn', { collapsible }]">
                    <template v-for="(msg, idx) in messages" :key="`message-box-${idx}`">
                        <div class="msg-ctn">
                            <message-box :class="get_message_class(idx)" @add-to-work="handleAddToWork"
                                @delete="handle('trash_message', $event)" @onselect="selectMessage(msg)"
                                @forward="handle('forward', $event)" @markunread="handle('markunread', $event)"
                                @reply="handle('reply', $event)" @replyall="handle('replyAll', $event)"
                                @set-reminder="handleSetReminder" :add-to-work-text="add_to_work_text" :message="msg"
                                :ref="get_message_ref_id(msg)" :selected="isSelectedMessage(msg)" :file="file_info" />
                            <span class="msg-expand-btn" v-if="is_view_collapsed && idx === 0"
                                :key="`msg-expand-btn-${idx}`" @click="collapsed = false"><span>{{ messages.length - 3
                                    }}</span>
                            </span>
                        </div>
                    </template>
                    <div class="eml-reply-buttons">
                        <o-button icon-left="reply" @click="handle('reply')">Reply</o-button>
                        <o-button icon-left="reply-all" @click="handle('replyAll')">Reply all</o-button>
                        <o-button icon-left="arrow-right" @click="handle('forward')">Forward</o-button>
                    </div>
                </div>
                <div class="eml-controls-box-ctn right">
                    <mail-controls-box @add-to-work="handleAddToWork" :add-to-work-text="add_to_work_text"
                        :references="references" />
                </div>
            </div>
        </div>
        <o-modal :can-cancel="['escape', 'outside', 'button']" scroll="keep" v-model:active="isReminderModalActive"
            has-modal-card>
            <reminder-modal :reference-id="reminder_reference_id" reference-type="email" />
        </o-modal>
        <!--      <o-modal :can-cancel="['escape', 'outside', 'button']" scroll="keep" v-model:active="isAddWorkModalActive" has-modal-card>-->
        <!--        <add-to-work-modal :references="references"/>-->
        <!--      </o-modal>-->
    </div>
</template>

<script>
import { UploadClient } from '@uploadcare/upload-client'
import { mapActions, mapGetters } from "vuex"
import AddContact from "../../modules/emails/AddContact"
import ComposeModal from "../../modules/emails/compose/ComposeModal"
import {
    fetch_file,
    fetch_message_files,
    fetchEmailByThreadId,
    fetchMessage,
    fetchMessageGmailIndividual,
    get_compose_message,
    mark_message_as_read,
    mark_message_as_unread,
    mark_thread_as_read,
    mark_thread_as_unread,
    trash_message,
    trash_thread,
    untrash_message,
    untrash_thread,
} from "../../modules/emails/gmail_api"
import AddToWorkModal from "./AddToWorkModal.vue"
import MailControlsBox from "./MailControlsBox.vue"
import MessageBox from "./MessageBox"

export default {
    components: {
        AddContact,
        MailControlsBox,
        MessageBox,
    },
    computed: {
        ...mapGetters(['emails_get_message', 'emails_get_profile', 'emails_is_signed_in', 'emails_label', 'emails_get_messages']),
        add_to_work_text() {
            return (
                (!!this.references && this.references.length && "Edit work") ||
                "Add to"
            )
        },
        belongs_to_current_user() {
            return this.emails_get_profile.email === Laravel.currentUser.email
        },
        collapsible() {
            const msg = this.selected_message
            let idx = 0, selected_msg_is_within_collapsed_zone = false
            if (msg) {
                idx = this.messages.findIndex(m => msg.message_id === m.message_id)
                selected_msg_is_within_collapsed_zone = idx > 0 && idx < this.messages.length - 3
            }
            return this.messages.length > 6 && this.selected_message && !selected_msg_is_within_collapsed_zone
        },
        contact_text() {
            return (!!this.message && this.message.from) || null
        },
        goback_link() {
            if (window.prevRoute && window.prevRoute.name === null) {
                return {
                    name: 'emails',
                    params: { label: this.go_back_to_label },
                }
            }
            return { ...window.prevRoute }
        },
        go_back_to_label() {
            return this.emails_label.split(',')[0]
        },
        is_view_collapsed() {
            return this.collapsible && this.collapsed
        },
        message_subject() {
            const message =
                (!!this.message && this.message) ||
                (!!this.messages && this.messages[0]) ||
                {}
            return message.subject || ""
        },
        references() {
            if (!!this.message && !!this.emailReferences && this.emailReferences.length > 0) {
                return this.emailReferences
            }
            return []
        },
        selected_message() {
            const { selected_id } = this.$route.params, l = this.messages.length || 0
            if (selected_id) {
                const message = this.messages.find(message => message.message_id === selected_id)
                if (message) {
                    this.selectMessage(message)
                    return message
                }
            }
            const message = l > 0 ? this.messages[l - 1] : null
            if (message) {
                this.selectMessage(message)
            }
            return message
        },
    },
    data() {
        return {
            collapsed: true,
            compose_message: {
                attaches: [],
                body: "",
                subject: "",
                from: "",
                to: [],
            },
            data: null,
            isReminderModalActive: false,
            isAddWorkModalActive: false,
            message: null,
            messages: [],
            reminder_reference_id: null,
            replyBoxActive: false,
            submitting: false,
            file_info: [],
            emailReferences: [],
        }
    },


    methods: {
        ...mapActions([
            "createFiles",
            "saveEmail",
            "setWork",
            'fetchReferences',
            'emails_set_message',
            'emails_set_messages',
        ]),
        ...mapActions({
            fetchThreadId: 'retrieveEmailByThreadId'
        }),

        decode(input) {
            // Replace non-url compatible chars with base64 standard chars
            input = input
                .replace(/-/g, '+')
                .replace(/_/g, '/');
            // Pad out with standard base64 required padding characters
            var pad = input.length % 4;
            if (pad) {
                if (pad === 1) {
                    throw new Error('InvalidLengthError: Input base64url string is the wrong length to determine padding');
                }
                input += new Array(5 - pad).join('=');
            }
            return input;
        },
        add_files_to_references(files, references = []) {
            const client = new UploadClient({ publicKey: UPLOADCARE_PUBLIC_KEY })
                , files_array = []
            references.length && files.forEach(file => fetch(file.path)
                .then(res => res.blob().then(fileData => client
                    .uploadFile(fileData, { fileName: file.name, contentType: file.mime })
                    .then(uc_file => {
                        references.forEach(reference => {
                            const data = {
                                name: file.name,
                                hash: file.hash_md5,
                                mime: file.mime,
                                path: uc_file.cdnUrl,
                                size: file.size,
                                uuid: uc_file.uuid,
                                reference_id: reference.reference_id,
                                reference_type: reference.reference_type,
                            }
                            if (reference.reference_type === 'project') {
                                data.project_id = reference.reference_id
                            }
                            files_array.push(data)
                        })
                        files_array.length && this.createFiles({ files: files_array })
                    })
                ))
            )
        },
        get_message_class(idx) {
            if (!this.collapsible || !this.collapsed) {
                return ''
            }
            const l = this.messages.length
            return idx === 0 && 'msg-first' || (l > 0 && idx === l - 1 && 'msg-last') || (l > 1 && idx === l - 2 && 'msg-penultimate') || 'msg-hidden'
        },
        get_message_ref_id(message) {
            return `message-${message.message_id}`
        },
        goBack() {
            this.$router.push({ name: 'emails', params: { label: this.go_back_to_label } })
        },
        handle(type, e) {
            const thread_id = !!this.message && (this.message.thread_id || this.message.message_id)
            switch (type) {
                case "cancelReply":
                    this.replyBoxActive = false
                    break
                case 'mark_thread_as_unread':
                    mark_thread_as_unread(thread_id).then(() => this.reversible_action(thread_id, mark_thread_as_read, 'Conversarion marked as unread'))
                    break
                case 'markunread':
                    const mark_read_unread = (message_id, read = true) => {
                        const promises = [], method = read ? mark_message_as_read : mark_message_as_unread
                        let start = false
                        this.messages.forEach(message => {
                            if (message_id === message.message_id) {
                                start = true
                            }
                            if (start) {
                                promises.push(method(message_id))
                            }
                        })
                        return Promise.allSettled(promises)
                    }
                    mark_read_unread(e.message_id, false).then(() => this.reversible_action(e.message_id, mark_read_unread, 'Message marked as unread'))
                    break
                case "forward":
                case "reply":
                case "replyAll":
                    const message = (!!e && !!e.message_id && e) || this.message
                    this.compose_message = {
                        ...this.compose_message,
                        ...get_compose_message(message, type),
                    }
                    const props = {
                        message: this.compose_message,
                    }
                    const events = {
                        cancel: e => this.handle('cancelReply', e),
                        sent: ($event) => this.handle("sent", $event),
                    }
                    this.openModalComponent(ComposeModal, props, null, events)
                    break
                case "sent":
                    this.init()
                    break
                case 'trash_message':
                    trash_message(e.message_id).then(() => this.reversible_action(e.message_id, untrash_message, 'Message moved to trash'))
                    break
                case 'trash_thread':
                    trash_thread(thread_id).then(() => this.reversible_action(thread_id, untrash_thread, 'Conversation moved to trash'))
                    break
                default:
                    break
            }
        },
        handleAddToWork() {
            const props = {}
            if (!this.messages || this.messages.length === 0) {
                return
            }
            if (!!this.message && Array.isArray(this.message.references)) {
                props.references = this.message.references
            }
            this.openModalComponent(AddToWorkModal, props).then(
                (references) => {
                    const setW = (message) => {
                        new Promise((resolve) => {
                            references.length && fetch_message_files(message).then(resolve) || resolve()
                        }).then(() => {
                            let files_hashes = []
                            if (Array.isArray(message.files)) {
                                files_hashes = message.files.filter(f => f.disposition !== 'inline').map(f => f.hash_md5)
                            }
                            // this.openLoading(false)
                            this.setWork({ id: message.id, files_hashes, references }).then(
                                ({ filtered_hashes = [], message: m }) => {
                                    this.$swal.fire({
                                        text: "Work added successful",
                                        icon: "success",
                                    })
                                    // this.openLoading(true)
                                    this.message = m
                                    for (let i = 0; i < this.messages.length; i++) {
                                        if (
                                            this.messages[i].message_id ===
                                            this.message.message_id
                                        ) {
                                            this.messages[i] = this.message
                                        }
                                    }
                                    this.add_files_to_references(message.files.filter(file => filtered_hashes.includes(file.hash_md5)), references)
                                    window.location.reload()
                                    // this.$children.filter(value => value.$el.className == "modal is-active").map(value => value.close())
                                }
                            )
                        })
                            .catch((err) => {
                                this.$swal.fire({
                                    text: `Error: ${err.message}`,
                                    icon: "danger",
                                })
                            })
                    }
                    const message = this.message || this.messages[0]
                    if (message && message.id) {
                        setW(message)
                    } else {
                        message.messages = []
                        let add = false
                        this.messages.forEach((m) => {
                            if (
                                m.thread_id === message.message_id &&
                                m.message_id !== message.message_id || add
                            ) {
                                message.messages.push(m)
                            }
                            if (message.message_id === m.message_id && message.message_id !== message.thread_id) {
                                add = true
                            }
                        })
                        this.saveEmail({ message }).then(
                            (res) => {
                                this.message = res.data.data
                                setW(this.message)
                            }
                        )
                    }
                }
            )
        },
        handleSetReminder(message) {
            new Promise((resolve) => {
                if (!message.id) {
                    this.saveEmail({ message }).then(
                        (res) => {
                            resolve(res.data.data)
                        }
                    )
                } else {
                    resolve(message)
                }
            }).then(m => {
                this.reminder_reference_id = m.id
                this.isReminderModalActive = true
            })
        },
        init(force = false) {
            let message_id = this.$route.params.message_id
            return new Promise((resolve) => {
                if (message_id || force) {

                    this.fetchReferences(message_id)
                        .then((value) => {
                            if (Array.isArray(value) && value.length > 0) {
                                this.emailReferences = value.flat()
                                this.message.references = value.flat()
                            }
                        })
                    fetchEmailByThreadId(message_id)
                        .then(
                            (m) => {
                                if (m.data.messages.length) {
                                    this.message = m.data.messages[0]
                                }
                                return fetchMessage(message_id)
                                    .then((result) => {
                                        const { data, messages } = result
                                        messages.forEach((message, idx) => {
                                            m.data.messages.forEach(lm => {
                                                if (lm.message_id === message.message_id) {
                                                    messages[idx] = lm
                                                }
                                            })
                                            const { references } = messages[idx]
                                            messages[idx].references = Array.isArray(references) && references.length ? references : this.message.references
                                            if (!messages[idx].id) {
                                                // if (this.message.references) {
                                                //   messages[idx].references = this.message.references
                                                // }
                                                this.saveEmail({ message: messages[idx] })
                                            }
                                        })
                                        this.data = data
                                        this.message = messages[0]
                                        this.messages = messages
                                        this.emails_set_message(this.message)
                                        this.emails_set_messages(this.messages)
                                        const msg = this.message
                                        !!msg &&
                                            Array.isArray(msg.label_ids) &&
                                            msg.label_ids.includes("UNREAD") &&
                                            mark_thread_as_read(message_id)
                                        resolve(this.message)
                                        return this.message
                                    }, () => {
                                        this.message = this.message || m[0]
                                        this.messages = [...m]
                                        resolve(this.message)
                                    })
                            },
                            () => {
                                if (!this.message || !this.message.id) {
                                    return fetchMessage(message_id)
                                        .then((result) => {
                                            for (const message of result.data.messages) {
                                                fetchMessageGmailIndividual(message.id)
                                                    .then((result) => result)
                                            }


                                            const { data, messages } = result
                                            this.data = data
                                            this.message = messages[0]
                                            this.messages = messages
                                            this.emails_set_message(this.message)
                                            this.emails_set_messages(this.messages)
                                            const m = this.message
                                            !!m &&
                                                Array.isArray(m.label_ids) &&
                                                m.label_ids.includes("UNREAD") &&
                                                mark_thread_as_read(message_id)
                                            resolve(this.message)
                                            return this.message
                                        })
                                }
                                resolve(this.message)
                                return Promise.resolve()
                            }
                        ).catch(err => {
                            if (err.response && err.response.status === 404 && err.response.data.error.message === 'Requested entity was not found.') {
                                // this.checkIfEmailIsSaved(message_id)
                            }
                        })
                }
            })
        },

        checkIfEmailIsSaved(message_id) {
            this.fetchThreadId(message_id).then(({ data }) => {
                this.data = data
                this.message = data[0]
                this.messages = data
                const msg = this.message
                !!msg &&
                    Array.isArray(msg.label_ids) &&
                    msg.label_ids.includes("UNREAD") &&
                    mark_thread_as_read(message_id)
                return this.message
            })
        },

        isSelectedMessage(msg) {
            return !!this.message && msg.message_id === this.message.message_id
        },
        reversible_action(message_id, callback, message, params) {
            const { actionText = 'Undo', position = 'is-bottom-left', type = 'is-warning' } = params || {}
            this.goBack()
            this.$swal.fire({
                actionText,
                message,
                onAction: () => {
                    callback(message_id).then(() => this.$router.go(), this.$snackbar.open({
                        duration: 1500,
                        text: 'Action undone',
                        position: 'is-bottom-left',
                    }))
                },
                position,
                type,
            })
        },
        selectMessage(message) {
            this.message = message
        },
    },
    created() {
        this.fetchThreadId(this.$route.params.message_id)
            .then((value) => {
                if (value) {
                    setInterval(() => {
                        this.emails_set_message(value[0])
                        this.emails_set_messages(value)
                        this.messages = value
                        this.message = value[0]
                    }, 800)

                    setTimeout(() => {
                        $(".sub-header").click()
                    }, 900)
                }
            })
            .catch((err) => {
                console.log(err)
            })
    },

    mounted() {
        this.init().then(() => {
            const l = (this.messages || []).length
            if (Array.isArray(this.messages) && l > 0) {
                const msg = this.selected_message,
                    refs = this.$refs[this.get_message_ref_id(msg)][0]
                refs.isOpen = true
                this.$nextTick(() => {
                    setTimeout(() => refs.$el.scrollIntoView({ block: 'start', behavior: 'smooth' }), 100)
                })
            }
        })

        setTimeout(async () => {
            for (const message of this.messages) {
                for (const fileElement of message.files) {
                    await fetch_file(fileElement).then(value => {
                        this.file_info.push(value)
                    })
                }
            }
        }, 2000)
    },

    watch: {
        $route(to, from) {
            if (to.params.message_id !== from.params.message_id) {
                this.init(true)
            }
        },
    },
}
</script>

<style lang="sass">
.eml-show-mail-container
  .eml-email
    background-color: #ffffff
    box-shadow: 0 2px 3px rgba(0, 0, 0, 0.1), 0 0 0 1px rgba(0, 0, 0, 0.1)
    color: #4a4a4a
    max-width: 100%
    position: relative
    .eml-topbar
      background-color: #f6f8fa
      border-bottom: 1px solid rgba(0, 0, 0, .1)
      color: #4a4a4a
      margin-bottom: 1px
      .header-buttons
        align-items: flex-start
        display: flex
        padding: 9px 6px 9px 0px
        margin-left: 5px
        .b-tooltip:first-child > .header-button
          margin-right: 12px
        .header-button
          height: 36px
          justify-content: center
          margin-right: 6px
          width: 36px
    .eml-email-header
      align-items: stretch
      box-shadow: 0 1px 2px rgba(0, 0, 0, 0.1)
      display: flex
      padding-bottom: 12px
      .eml-header-title
        align-items: flex-start
        color: #363636
        display: flex
        flex-direction: column
        flex-grow: 1
        font-weight: 550
        padding: 0.75rem
        .title
          font-weight: 500
          margin-bottom: 8px
          padding-bottom: 0
        .actions
          > *:first-child
            margin-right: 12px
          .icon
            width: auto
      .header-buttons
        align-items: flex-start
        display: flex
        padding: 0.75rem
        .header-button
          height: 36px
          justify-content: center
          width: 36px
        >.header-button:after
          background: silver
          content: ''
          display: block
          height: 21px
          margin-left: 37px
          margin-top: 0px
          margin-right: 2px
          position: absolute
          width: 1px
        .dropdown
          flex-grow: 0
    .eml-email-content
      display: flex
      .eml-messages-box-ctn
        border-right: 1px solid rgba(0, 0, 0, 0.1)
        flex: 1px
        .msg-ctn
          position: relative
        .eml-reply-buttons
          display: flex
          margin-bottom: 18px
          margin-left: 18px
          margin-top: 12px
          padding: 16px 0
          >button
            margin-right: 12px
        &.collapsible
          position: relative
          .msg-first
            margin-bottom: 5px
          .msg-hidden
            display: none
          .msg-expand-btn
            align-items: center
            background-color: white
            border-radius: 20px
            box-shadow: inset 0 0 0 1px #dadce0
            color: #5f6368
            display: flex
            font-family: Roboto,RobotoDraft,Helvetica,Arial,sans-serif
            font-size: .75rem
            height: 32px
            justify-content: center
            left: 13px
            letter-spacing: .3px
            padding: 0
            position: absolute
            top: 100%
            transform: translateY(-50%)
            width: 32px
            z-index: 1
            -webkit-align-items: center
            -webkit-border-radius: 20px
            -webkit-box-shadow: inset 0 0 0 1px #dadce0
            &:hover
              background-color: #f2f2f2
              font-size: 0
              &:before
                background-image: url('https://www.gstatic.com/images/icons/material/system/1x/expand_all_black_20dp.png')
                background-position: center
                background-repeat: no-repeat
                background-size: 20px
                content: ''
                height: 20px
                opacity: .71
                width: 20px
      .eml-controls-box-ctn
        padding-left: 0.75rem
        &.right
          width: 400px
</style>